module.exports = __webpack_public_path__ + "static/media/microsoft_icon.2ab49f41.svg";